import { HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestService } from '@commonServices/request.service';
import { Client as CatalogAPI, FileParameter, OrcaAdminCatalogAndNewsDto, OrcaAdminInhouseNewsDto, OrcaAdminInhouseNewsListDto } from "@interfaces/HttpClient/CatalogApiModels";
import { firstValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class OrcaAdminNewsService {

	constructor(
		private catalogApi: CatalogAPI,
		private requestService: RequestService
	) { }


	public async getNews(): Promise<OrcaAdminInhouseNewsListDto> {
		try {
			return await this.catalogApi
				.orcaAdminNews_GetNews()
				.toPromise();
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	public async getNewNewsInfo(): Promise<OrcaAdminInhouseNewsDto> {
		try {
			return await this.catalogApi
				.orcaAdminNews_GetNewNewsInfo()
				.toPromise();
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}


	public async createNews(dto: OrcaAdminInhouseNewsDto, croppedFile?: FileParameter, originalFile?: FileParameter): Promise<OrcaAdminInhouseNewsDto> {
		try {
			return await this.catalogApi
				.orcaAdminNews_CreateOrcaAdminNews(
					dto.type,
					dto.title,
					dto.text,
					dto.teaser,
					dto.videoUrl,
					dto.brand,
					dto.categoryType,
					dto.keywords,
					dto.isPublicView,
					dto.isAdminView,
					dto.additionalInformationsUrl,
					dto.visibility,
					dto.startDate,
					dto.endDate,
					croppedFile,
					originalFile
				)
				.toPromise();
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}


	public async updateNews(dto: OrcaAdminInhouseNewsDto, croppedFile?: FileParameter, originalFile?: FileParameter): Promise<OrcaAdminInhouseNewsDto> {
		try {
			return await this.catalogApi
				.orcaAdminNews_UpdateNews(
					dto.id,
					dto.type,
					dto.title,
					dto.text,
					dto.teaser,
					dto.videoUrl,
					dto.brand,
					dto.categoryType,
					dto.keywords,
					dto.isPublicView,
					dto.isAdminView,
					dto.additionalInformationsUrl,
					dto.visibility,
					dto.startDate,
					dto.endDate,
					croppedFile,
					originalFile
				)
				.toPromise();
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	public async duplicateNews(newsId: number): Promise<OrcaAdminInhouseNewsDto> {
		try {
			return await this.catalogApi
				.orcaAdminNews_DuplicateNews(newsId)
				.toPromise();
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	public async deleteNews(newsId: number): Promise<void> {
		try {
			return await this.catalogApi
				.orcaAdminNews_DeleteNews(newsId)
				.toPromise();
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	public async getCatalogsAndNews(showOnlyActive: boolean): Promise<OrcaAdminCatalogAndNewsDto[]> {
		try {
			return firstValueFrom(this.catalogApi
				.orcaAdminNews_GetAllCatalogsAndNews(showOnlyActive));
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	public async getPublicNewsCount(): Promise<number> {
		try {
			return firstValueFrom(this.catalogApi
				.orcaAdminNews_GetActiveNewsCount());
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: 0 }
			]);
		}
	}
}
